<template>
  <div id="prescriber">
    <h2>{{ $t('pages.memorial.edit') }}</h2>
    <b-container>
      <ajax-edit
        :name="name"
        :uri="uri"
        :id="id"
        :additionnal-route="additionnalRoute"
        :config="{ headers: { 'Content-Language': $translation.getLocale() } }"
      />
    </b-container>
  </div>
</template>

<script>
  import AjaxEdit from '@triotech/vue-core/src/components/ajax/AjaxEdit';

  export default {
    name: 'MemorialEdit',
    components: {
      AjaxEdit,
    },
    data() {
      return {
        id: this.user().memorial.id,
        name: 'memorial',
        uri: 'api/memorial',
        additionnalRoute: 'dead',
      };
    },
  };
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Memorial/edit.vue